import type { AppPaneName, HeaderPaneName } from "owa-app-pane-group-types";
import { isCapabilityEnabled } from "owa-capabilities";
import { newHeaderCapability } from "owa-capabilities-definitions/lib/newHeaderCapability";
import { isDrawerPaneVisible } from "owa-drawer";
import { isFlexPaneShown } from "owa-suite-header-store/lib/selectors/isFlexPaneShown";
import { APP_PANE_NAME_PREFIX, HEADER_PANE_NAME_PREFIX } from "../constants/constants";
import isAppPane from "../utils/isAppPane";
import isHeaderPane from "../utils/isHeaderPane";

export default function isFlexPaneShownHelper(suitePaneName?: string, paneName?: AppPaneName | HeaderPaneName): boolean {
    if (!isCapabilityEnabled(newHeaderCapability)) {
        return isFlexPaneShown(suitePaneName);
    }
    
    if (!paneName) {
        return isDrawerPaneVisible();
    }
    
    if (isAppPane(paneName)) {
        return isDrawerPaneVisible(`${APP_PANE_NAME_PREFIX}${paneName}`);
    }
    
    if (isHeaderPane(paneName)) {
        return isDrawerPaneVisible(`${HEADER_PANE_NAME_PREFIX}${paneName}`);
    }
    
    return isFlexPaneShown(suitePaneName);
}
